import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Dropdown } from "antd";
import "./ExportButton.css";
import Arrow from "../../../assets/icons/arrow.png";
import Export from "../../../assets/icons/export.svg";
import { useParams } from "react-router-dom";

const exportToCSV = (data, filename = "data.csv") => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const csvOutput = XLSX.utils.sheet_to_csv(worksheet);
  const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
  //explicitly extension provided as the filename includes '.' notations
  saveAs(blob, filename + ".csv");
};

const exportToExcel = (data, filename = "data.xlsx") => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array"
  });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });
  //explicitly extension provided as the filename includes '.' notations
  saveAs(blob, filename + ".xlsx");
};

const ExportButton = ({ data, type }) => {
  const { plantCode } = useParams();
  const fileName = `${plantCode}_${type}`;

  const handleMenuClick = (e) => {
    switch (e.key) {
      case "csv":
        exportToCSV(data, fileName);
        break;
      default:
        console.log("failed case :: export button menu option", e.key);
    }
  };

  const menu = {
    items: [
      {
        label: "Export CSV",
        key: "csv"
      }
    ],
    onClick: handleMenuClick
  };

  return data.length ? (
    <div>
      <Dropdown.Button
        className="custom-dropdown-btn"
        menu={menu}
        onClick={() => exportToExcel(data, fileName)}
        icon={<img src={Arrow} height={8} alt=":" />}
      >
        <img src={Export} height={16} alt="export" />
        Export Excel
      </Dropdown.Button>
    </div>
  ) : null;
};

export default ExportButton;
